<template>
<q-page >
    <!-- <div class="q-px-md text-h6 q-pt-sm"> {{$t("FundInfo.title")}} </div> -->
     <Account class="q-pa-md "/>

    <!-- <div class="text-h6 q-pa-md col-xs-12 col-sm-12 col-md-12">{{ $t("Redeem.title") }}</div> -->
    <div class="q-pa-md">

      <q-list>
        <q-item  style="padding: 0px" >
            <!-- <q-item-section style="border:1px solid #063ca1; border-radius: 1rem !important"> -->

            <q-item-section  class="" style="border-radius: 0.5rem; border: 1px solid #e0e0e0; background: #fff; margin-bottom: 0px; box-shadow: none; background: #fff;">
                <div class="" >
                  <div class="text-bold q-pa-md" style="font-size: 16px;">{{ $t("Redeem.title") }} </div>
                  <q-separator style="margin: 0 0.75rem; width: auto;"/>
                </div>

                <q-item v-if="StoreStateCD.Holdings.length < 1">
                    <q-item-section>
                        {{$t("Redeem.nocontent")}}
                    </q-item-section>
                </q-item>

                <div class="row">
                  <!-- StoreStateCD.Holdings or dummyData--> 
                <div class="q-px-md q-pt-md col-xs-12 col-md-12" v-bind:key="Holding.index" v-for="Holding in StoreStateCD.Holdings">
                  <q-item-section class="q-pa-none" style="">
                    <div class="row q-mb-sm">
                        <div class="col-12 q-pl-sm q-mb-md schemeName">
                            <!-- <q-input :label='$t("Redeem.fund")'  :value="Holding.ProductName" readonly borderless /> -->
                          <!-- <b>{{$t("Redeem.fund")}}</b> -->
                          <div class="text-bold" style="font-size: 15px;">{{ Holding.ProductName }}</div>
                        </div>

                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                            <div class="fieldStyle">
                            <b>{{$t("Redeem.totalamount")}}</b>
                            <div>{{ Holding.Amount }}</div>
                            </div>
                              <!-- <q-field 
                                v-model="Holding.Amount"
                                borderless >
                                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                                    <money readonly :id="id" class="q-field__native" :value="value" @input="emitValue" v-bind="money"  v-show="floatingLabel"/>
                                </template>
                            </q-field> -->
                        </div>
                            
                       

                      <!-- <div class="col-xs-12 q-mb-md">
                          <b>{{$t("Redeem.totalamount")}}</b>
                          <div>{{ Holding.Amount }}</div>
                      </div> -->
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                        <div class="fieldStyle">
                            <b>{{$t("Redeem.plan")}}</b>
                            <div>{{Holding.Plan}}</div>
                        </div>
                      </div>

                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                        <div class="fieldStyle">
                          <b>{{$t("Redeem.currency")}}</b>
                          <div>{{Holding.Currency}}</div>
                        </div>
                      </div>
                    
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                        <div class="fieldStyle" >
                            <b>{{$t("Redeem.currentnav")}}</b>
                            <div>{{Holding.NAV}}</div>
                        </div>
                      </div>

                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                        <div class="fieldStyle" >
                            <b>{{$t("Redeem.pendingRedemption")}}</b>
                            <div>{{formatthousandseparator(Holding.pendingRedemptionUnit)}}</div>
                        </div>
                      </div>
                    
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm">
                        <div class="fieldStyle" >
                          <b>{{$t("Redeem.balanceunit")}}</b>
                          <div>{{formatthousandseparator(Holding.BalanceUnit)}}</div>
                        </div>
                      </div>
                    </div>

                    <!-- "click to redeem" -->
                    <div class="row text-center q-mb-md q-pr-sm" style="margin-top: auto;">
                      <div class="col-xs-12">
                        <FT
                          :FundName=Holding.ProductName
                          :Plan=Holding.Plan
                          :FundCurrency=Holding.Currency
                          :BalanceUnit=Holding.BalanceUnit  
                          :BalanceUnitA=Holding.BalanceUnitA
                          :BalanceUnitB=Holding.BalanceUnitB
                          :Amount=Holding.Amount
                          :ProductType=Holding.ProductType
                          :AccountType=StoreStateCD.Account.AccountType
                          :SchemeName=Holding.ProductName
                          :Scheme=Holding.Scheme
                          :NAV=Holding.NAV
                          :NAVDate=Holding.NAVDate
                        />
                      </div>
                    </div>

                    </q-item-section>
                    <!-- end redemption confirmation card -->

                    <!--
                    <div class="row text-center q-px-sm">
                      <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.plan")}}</a><br>
                        <a class="">{{Holding.Plan}}</a>
                      </div>
                      <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.currency")}}</a><br>
                        <a class="text-center">{{Holding.Currency}}</a>
                      </div>
                      <div class="col-xs-12 col-sm-2 col-md-2 q-pa-sm" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.currentnav")}}</a><br>
                        <a class="text-center">{{Holding.NAV}}</a>
                      </div> -->
                      <!-- not used by mohan 
                        <div class="col" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.unitholding")}}</a><br>
                        <a class="text-center " >{{Holding.Amount.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})|thousandSeparator}}</a>
                      </div> -->
                      <!--
                     <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.pendingRedemption")}}</a><br>
                        <a class="text-center">{{ formatthousandseparator(Holding.pendingRedemptionUnit)}}</a>
                      </div>
                      -->
                       <!-- not used by mohan
                         <div class="col" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">Pending Investment/ Switch In</a><br>
                        <a class="text-center">{{ formatthousandseparator(Holding.pendingInvestmentUnit)}}</a>
                      </div> -->
                      <!--
                      <div class="col-xs-12 col-sm-3 col-md-3 q-pa-sm" style="border:1px solid #A6A6A6">
                        <a class="text-grey-6">{{$t("Redeem.balanceunit")}}</a><br>
                        <a class="text-center">{{ formatthousandseparator(Holding.BalanceUnit)}}</a>
                      </div>
                    </div>
                    end "table" -->
                  <q-separator style="margin: 0 0.75rem; width: auto;" v-if="StoreStateCD.Holdings.indexOf(Holding) + 1 != StoreStateCD.Holdings.length"/>
                    
                  </div>
                </div>
            </q-item-section>
            
        </q-item>
        <!-- "No Content" -->
        <!-- <q-item v-if="StoreStateCD.Holdings.length < 1">
            <q-item-section>
                {{$t("Redeem.nocontent")}}
            </q-item-section>
        </q-item> -->
      </q-list>

      <div v-if="StoreStateCD.NonEPFHoldings.length > 0" class="q-pa-sm q-mt-md" style="border-radius: 0.5rem; border: 1px solid #e0e0e0; background: #fff;">
          <q-toggle    
            v-model="StoreStateT.showOtherEPFScheme"
            @input="TriggerEmisArray($event)"        
            color="green-14"
            :label='$t("common.showotherepf")'
            right-label
          />
      </div>
      
      <!-- <q-toggle v-if="StoreStateCD.NonEPFHoldings.length > 0" v-model="StoreStateT.showOtherEPFScheme"  @input="TriggerEmisArray($event)" checked-icon="check" color="primary" :label='$t("common.showotherepf")' left-label  unchecked-icon="clear"  /> -->

      
    </div>
    
    <div class="row q-pa-md" >
      <q-card bordered class="page" style="width:100%; border: 1px solid #e0e0e0; border-radius: 0.5rem; margin-bottom: 20px; box-shadow: none; background: #fff;">
        <!-- <div class="q-pa-md">
          <div class="text-bold" style="font-size: 16px;">{{ $t("Redeem.mycart") }} </div>
        </div> -->

        <div class="">
          <div class="text-bold q-pa-md" style="font-size: 16px;">{{ $t("Redeem.mycart") }} </div>
          <q-separator style="margin: 0 0.75rem; width: auto;"/>
        </div>

        <q-card-section style="padding: 0px !important;" class="scroll" >
          <ShoppingCart/>
        </q-card-section>
      </q-card>

      <div class="text-right" style="width: 100%">
          <q-btn :label='$t("common.continueBtn")' style="background: #ff6666; color: white;" @click="ConfirmedCart(); scrollPositionToTop();" unelevated />
      </div>
    </div>
    
 </q-page >
</template>

<style>
@media screen and (min-width: 600px) {
  .fieldStyle{
    border: 1px solid #e0e0e0; border-radius: 0.5rem; padding: 8px 12px; height: 100%;
  }
}

/* .gridItem{
  height: 100%; margin-bottom: 0px; box-shadow: none; background: #fff;
}

@media screen and (max-width: 768px) {
  .gridItem{
    border-radius: 0rem !important;
    border: none !important;
    padding: 0px !important;
    padding-bottom: 16px !important;
    border-bottom: 1px solid #e0e0e0 !important;
  }

}

@media screen and (min-width: 769px) {
  .gridItem{
    border: 1px solid #e0e0e0; 
    border-radius: 0.5rem;
  }
  
} */
</style>

<script>
import store from '../store';
import { mapState, mapActions, mapGetters } from "vuex";
import {VMoney, Money} from 'v-money'
import CD from "@/components/ClientDetails";
import FT from "./FundTransaction";
//import FIInfo from './FundInvestmentInfo'
//import FTNF from "./FundTransactionNewFund";
import Account from '@/components/AccountDetails_2'
import ShoppingCart from '@/components/ShoppingCartPrototype.vue'
//import SATProfileDetails from '@/components/SATProfileDetails.vue'
//import BasisRecommendation from '@/components/BasisRecommendation.vue'
import { date, uid } from 'quasar';
export default {
  components: {
    FT,
   // FTNF,
    //FIInfo,
    ShoppingCart,
   // BasisRecommendation,
    //SATProfileDetails,
    Account,
    Money
  },
  data() {
    return {
      BuyNewFundModal: false,
      CartModal : false,
      StoreStateCD: store.state.CD,
			StoreStateAOD : store.state.AOD,  
      StoreStateT : store.state.Transactions,   
      TransactionId : '',
      BasisRecommendationModal : false,
      StoreStateAD : store.state.AD,
      StoreStateLogin: store.state.Login,
      tempMobileNo:'',
      money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false /* doesn't work with directive */
      },
      dummyData: [ { "CustomerId": "670529013823", "AccountID": "920000000413", "Scheme": "SOF", "ProductName": "SELECT OPPORTUNITY FUND", "Plan": "EPF", "FloatingUnit": "0.00", "pendingRedemptionUnit": "1100.00", "pendingInvestmentUnit": "1100.00", "BalanceUnit": "2097.27", "Amount": "2934.45", "NAV": "0.9178", "NAVDate": "2020-10-10", "Channel": "AHAM", "Currency": "MYR" },
      { "CustomerId": "670529013823", "AccountID": "920000000413", "Scheme": "SOF", "ProductName": "SELECT OPPORTUNITY FUND", "Plan": "EPF", "FloatingUnit": "0.00", "pendingRedemptionUnit": "1100.00", "pendingInvestmentUnit": "1100.00", "BalanceUnit": "2097.27", "Amount": "2934.45", "NAV": "0.9178", "NAVDate": "2020-10-10", "Channel": "AHAM", "Currency": "MYR" } ]

    };
  },
  mounted() {
   /*  this.$q.loading.show({
            spinnerSize : 50
        }),
    this.GetListOfFund();
    this.GetCif({
      ApplicationId : '910328106187'
    }).then(res=>{
                    this.$q.loading.hide()
                })
  
   
   this.GetAccountHoldings({
        AccountId: this.StoreStateCD.Account.AccountId
      })*/
  },
  computed: {
    ...mapGetters([
      "cartCount" 
      ]),
  },
  filters: {
		thousandSeparator: function(value) {
			if (value !== undefined) {
				return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return value;
			}
		}
  },
  methods: {
    ...mapActions([
        "PostTransaction",
        "GetListOfFund",
        "FilterFundPlanByProductType",
        "PostSATDetails",
        "GetAccountHoldings",
        "GetCif",
        "RequestTAC",
        "TransactRedeemProcess",
        "PostTransaction_Submit",
        "eMISTransactionConfirmSwitchRedeem",
        "getTransaction",
        "GetApplicationAvailableUnitCheck"
    ]),

    
    OpenCartModal(){
      this.CartModal = true;
    },

    TriggerEmisArray(event){

      this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerEmisArray(Redeem), -> showOtherEPFScheme-> ' + this.StoreStateT.showOtherEPFScheme 
        });

      if(this.StoreStateT.showOtherEPFScheme === true){
        for(var i=0; i< this.StoreStateCD.NonEPFHoldings.length; i++){
          this.StoreStateCD.Holdings.push({
            CustomerId: this.StoreStateCD.NonEPFHoldings[i].CustomerId,
            AccountID: this.StoreStateCD.NonEPFHoldings[i].AccountID,
            Scheme: this.StoreStateCD.NonEPFHoldings[i].Scheme,
            ProductName: this.StoreStateCD.NonEPFHoldings[i].ProductName,
            Plan: this.StoreStateCD.NonEPFHoldings[i].Plan,
            FloatingUnit : parseFloat(this.StoreStateCD.NonEPFHoldings[i].FloatingUnit).toFixed(2),
            pendingRedemptionUnit : parseFloat(this.StoreStateCD.NonEPFHoldings[i].pendingRedemptionUnit).toFixed(2),
            pendingInvestmentUnit: parseFloat(this.StoreStateCD.NonEPFHoldings[i].pendingRedemptionUnit).toFixed(2),
            BalanceUnit: parseFloat(this.StoreStateCD.NonEPFHoldings[i].BalanceUnit).toFixed(2),
            Amount: parseFloat(this.StoreStateCD.NonEPFHoldings[i].Amount).toFixed(2),
            BalanceUnitA: this.StoreStateCD.NonEPFHoldings[i].BalanceUnitA,
            BalanceUnitB: this.StoreStateCD.NonEPFHoldings[i].BalanceUnitB,
            BalanceAmountA: this.StoreStateCD.NonEPFHoldings[i].BalanceAmountA,
            BalanceAmountB: this.StoreStateCD.NonEPFHoldings[i].BalanceAmountB,
            NAV: this.StoreStateCD.NonEPFHoldings[i].NAV,
            NAVDate: this.StoreStateCD.NonEPFHoldings[i].NAVDate,
            Channel : this.StoreStateCD.NonEPFHoldings[i].Channel,
            AgentID: this.StoreStateCD.NonEPFHoldings[i].AgentID,
            Currency: this.StoreStateCD.NonEPFHoldings[i].Currency
          })
        }

      }
      if(this.StoreStateT.showOtherEPFScheme === false){
  

         for(var i=0; i< this.StoreStateCD.Holdings.length; i++){
          if(this.StoreStateCD.Holdings[i].Channel==='AHAM'){             
              this.StoreStateCD.Holdings.splice(i,this.StoreStateCD.Holdings.length)
          }
        } 

         if(this.StoreStateCD.Transaction.Redemption.length>0){
          this.$q.loading.show({
              spinnerSize: 50
          })
          
        this.StoreStateCD.Transaction.Redemption = []
        this.GetAccountHoldings()
          .then(res => {
              this.$store.dispatch('Logging',{
                  appid : '2',
                  typeid :'4', 
                  str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetAccountHoldings (Redeem) reset, ID Type -> . res - > '+  res
              });

              if (res == true) {
                this.PostTransaction({
                    ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
                  })
                    .then(res=>{

                      this.$store.dispatch('Logging',
                      {
                          typeid :'4', 
                          appid : '2',
                          str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' RESET DRAFT CART (redeem)-> ' + this.StoreStateCD.FormDetails.ApplicationId + '. res --> ' + res
                      });
                      if(res!=true){
                          this.$q.loading.hide()
                          this.$q.dialog({
                              title: 'Error',
                              message:  res ,
                          })    
                      }
                      else{
                        this.$q.loading.hide()
                      }
                    })    
              } else if(res === -1){
                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings reset (Redeem), error ' //+ res
                });

                  this.$q.dialog({
                    title: 'Error',
                    message : 'Investor Holding details API is not responding'
                })
                    this.$q.loading.hide()
              }else{
                    this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetAccountHoldings reset (Redeem), error ' //+ res
                    });
                    this.$q.dialog({
                        title: 'Error',
                        message : res
                    })
                  this.$q.loading.hide()
                }
          })
            
        }  


      }
    },
    ConfirmedCart(){
      if((this.StoreStateCD.Transaction.Investment.length > 0)||(this.StoreStateCD.Transaction.Redemption.length > 0)||(this.StoreStateCD.Transaction.Switching.length > 0)){
        this.$q.loading.show({
              spinnerSize: 50
            }),

        this.CartModal = false
        var vm = this;
        
       // this.PostTransaction_Submit().then(res=>{
         // if(res===true){
           this.getTransaction().then(res=>{
             if(res === true){
               
                    if(this.StoreStateT.Redemption.length > 0){
                      var minRedeem = 0;
                      var accBal=0;
                      var availableUnit = 0;
                      var redeemhUnit = 0;
                      var checking = true;
                      var msg= '';
                      var SchemeName = '';


                      for(var i=0; i<this.StoreStateT.Redemption.length; i++ ){
                        minRedeem = this.StoreStateT.Redemption[i].MinimumRepurchaseUnits,
                        accBal = this.StoreStateT.Redemption[i].MinimumAccountBalance,
                        availableUnit = this.StoreStateT.Redemption[i].AvailableUnits 
                        //- this.StoreStateT.Switching[i].Units
                        redeemhUnit = this.StoreStateT.Redemption[i].Units
                        SchemeName = this.StoreStateT.Redemption[i].SchemeName
                        
                        this.$store.dispatch('Logging',
                        {
                            typeid :'5', 
                            appid : '2',
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirmSwitchRedeem(redeem) cart detail, -> availableUnit ->'+ availableUnit +' redeemUnit -> ' + redeemhUnit +' < MinimumRepurchaseUnits :'+ minRedeem +"-->" + SchemeName
                        });
                        
                       // console.log(availableUnit)
                      //  if(availableUnit >= minRedeem){

                        if(parseFloat(availableUnit) != 0){
                          if(redeemhUnit < minRedeem){
                            checking = false
                            msg = 'Minimum Redemption Units for ' + SchemeName + ' is :' + minRedeem + " Units"
                            
                            this.$q.loading.hide()
                            this.$q.dialog({
                                title : 'Error',
                                message :  msg 
                              })
                          }
                        }
                          
                        //}
                        
                      }
                    }

                    if(checking === true){ 
                        this.GetApplicationAvailableUnitCheck({
                        applicationId: this.StoreStateCD.FormDetails.ApplicationId 
                      }).then(res=>{
                        if(res === "1"){
                          if(this.StoreStateT.fundUnitConfirm.length>0){
                              for(var i=0; i<this.StoreStateT.fundUnitConfirm.length; i++){
                                msg = 'Insufficient Unit for ' + this.StoreStateT.fundUnitConfirm[i].SchemeName + ' ,Transaction Units : '+ this.StoreStateT.fundUnitConfirm[i].TransactionUnit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +' Units , Available Units : ' + this.StoreStateT.fundUnitConfirm[i].SchemeUnitAvailable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " Units"
                            
                                this.$q.loading.hide()
                                this.$q.dialog({
                                  title : 'Unable to proceed Redemption.',
                                  message :  msg 
                                })
                              }
                          }else{
                            this.eMISTransactionConfirmSwitchRedeem({
                                DigitalID : this.StoreStateCD.FormDetails.ApplicationId
                              }).then(res=>{
                                this.$store.dispatch('Logging',
                                  {
                                      typeid :'5', 
                                      appid : '2',
                                      str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' eMISTransactionConfirmSwitchRedeem(Redeem), -> res -> ' + res
                                  });
                              if(res===true){
                                this.StoreStateAD.OpenPopUp = true;
                                this.$q.loading.hide()
                                vm.StoreStateAD.RedemptionStep = '2';
                              }else{
                                this.$q.loading.hide()
                                this.$q.dialog({
                                      title : 'Message',
                                      message : 'Something went wrong. ' + res 
                                  })
                              }
                            }) 
                          }
                        }else{
                          this.$q.loading.hide()
                          this.$q.dialog({
                            title : 'Warning',
                            message :  res 
                          })
                        }
                      })
                     
                     } 
               
             }else{  
                this.$q.loading.hide()
                this.$q.dialog({
                  title : 'Error',
                  message :  res 
                })
              }  
             
           })
            
           /* }else{
            this.$q.loading.hide()
            this.$q.dialog({
              title : 'Message',
              message : 'Something went wrong. ' + res 
            })
          } */
       // })
      }else{
        return false
      } 
    },
    toAccountVerification:function(){
   

      this.$store.dispatch('Logging',
        {
            typeid :'5', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' RequestTAC (Redeem), -> RequestTAC -> ' + this.StoreStateAOD.ContactInformation.MobileNo +' res:'+ res
        });

            //this.StoreStateAOD.ContactInformation.MobileNo  ='0149638728'
            this.formatMobileNo();
            this.RequestTAC({
                CustomerTelMobile : this.StoreStateAOD.ContactInformation.MobileNo,
                Purpose : 'I-Invest - Account Verification',
                CustomerId : this.StoreStateAOD.PersonalInformation.NRIC,
                RIDType : ''
            })
            .then(res=>{
                if(res===true){  
                    this.$q.dialog({
                        title : 'Message',
                        message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo
                    })
                }else{
                        this.$q.dialog({
                            title :  'Warning',
                            message :  res
                        })
                    }
            }) 
        },
        formatMobileNo:function() {
          
            //this.StoreStateAOD.ContactInformation.MobileNo  ='0149638728'
        var mobileNo = this.StoreStateAOD.ContactInformation.MobileNo          
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      },
    DoneBasisRecommendation(){
      if(this.StoreStateCD.SAT.ReferenceId===''){
        this.StoreStateCD.SAT.ReferenceId = uid();
      }
      this.PostSATDetails({ReferenceId:this.StoreStateCD.SAT.ReferenceId})
      .then(res=>{
        if(res==='error'){
          this.$q.dialog({
              title: 'Error',
              message: 'Something went wrong. Please contact your administrator.',
          })    
        }
        else{
          this.BasisRecommendationModal = false
          this.$router.push({name:'Payment'})
        }
      })
    },
    AddtoCart(){
      this.CreateTempId();
      this.CreateFundTransaction_Investment();
      this.PostTransaction({
          ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
      })
      .then(res=>{
        if(res==='error'){
          this.$q.dialog({
              title: 'Error',
              message: 'Something went wrong. Please contact your administrator.',
          })    
        }
        else{
          this.BuyNewFundModal = false;
          this.ClearNewFundModal();
        }
      })
    },
    CreateFundTransaction_Investment(){
      this.StoreStateCD.Transaction.Investment = []
      this.StoreStateCD.Transaction.Investment.push({
        Id: this.TransactionId,
        Amount : this.$refs.refFTNF.Form.Amount,
        SalesCharge : this.$refs.refFTNF.Form.SalesCharge,
        SmartSave : this.$refs.refFTNF.Form.SmartSave,
        SmartSaveStartDate : date.formatDate(this.$refs.refFTNF.Form.SmartSaveStartDate, 'YYYY-MM-DD'),
        SmartSaveEndDate : date.formatDate(this.$refs.refFTNF.Form.SmartSaveEndDate, 'YYYY-MM-DD'),
        ModeOfFrequency : this.$refs.refFTNF.Form.ModeOfFrequency,
        DateOfDeduction : this.$refs.refFTNF.Form.DateOfDeduction,
        FundID : this.$refs.refFTNF.Form.FundCode.value,
        FundName : this.$refs.refFTNF.Form.FundCode.label,
        Plan : this.$refs.refFTNF.Form.Plan,
        FundCurrency : this.$refs.refFTNF.Form.Currency,
        TypeOfProduct : this.StoreStateCD.Account.AccountType,
        DistributionInstruction : this.$refs.refFTNF.Form.DistributionInstruction
      })
    },
    CreateTempId() {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (dt + Math.random()*16)%16 | 0;
          dt = Math.floor(dt/16);
          return (c=='x' ? r :(r&0x3|0x8)).toString(16);
      });
      this.TransactionId =  uuid;
    },
    BuyNewFund() {
      if(
        this.StoreStateCD.SAT.InvestmentObjective.value===''
        || this.StoreStateCD.SAT.InvestmentPeriod.value===''
        || this.StoreStateCD.SAT.EstimatedNetWorth.value===''
        || this.StoreStateCD.SAT.EstimatedLiability.value===''
        || this.StoreStateCD.SAT.AnnualisedGain.value===''
        || this.StoreStateCD.SAT.Age.value===''
        || this.StoreStateCD.SAT.AnnualIncome.value===''
        || this.StoreStateCD.SAT.RiskTolerance.value===''
        || this.StoreStateCD.SAT.Bonds===''
        || this.StoreStateCD.SAT.Derivatives===''
        || this.StoreStateCD.SAT.Equities===''
        || this.StoreStateCD.SAT.UTF===''
      ){
        this.$q.dialog({
            title: 'Message',
            message: 'Kindly complete Suitability Assessment.',
        })
        .onOk(() => {
            this.$router.push({name : 'sat'})
        })
      }
      else{
        this.BuyNewFundModal = true;
        this.FilterFundPlanByProductType({ ProductType: this.StoreStateCD.Account.AccountType })
      }
    },
    ClearNewFundModal(){
      this.$refs.refFTNF.Form.Id = ''
      this.$refs.refFTNF.Form.Plan = ''
      this.$refs.refFTNF.Form.FundName = ''
      this.$refs.refFTNF.Form.FundCode = ''
      this.$refs.refFTNF.Form.DisagreeRecommendation = false
      this.$refs.refFTNF.Form.Amount = 0
      this.$refs.refFTNF.Form.SalesCharge = 0
      this.$refs.refFTNF.Form.SmartSave = false
      this.$refs.refFTNF.Form.SmartSaveStartDate = ''
      this.$refs.refFTNF.Form.SmartSaveEndDate = ''
      this.$refs.refFTNF.Form.ModeOfFrequency = ''
      this.$refs.refFTNF.Form.DateOfDeduction = []
      this.$refs.refFTNF.Form.MinInvAmt = 0
      this.$refs.refFTNF.Form.Currency = 'MYR'
    },
    GoToSAT(){
      this.$router.push({name:"sat"})
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatthousandseparator(value) {
      //let val = (value / 1).toFixed(2).replace(",", ".");
        if(value != undefined){

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
       }
    },
    scrollPositionToTop(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  }
};
</script>

<style scoped>
.q-field__inner {
    text-align: right;
}


</style>